var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.75C6.94922 0.75 8.125 1.92578 8.125 3.375V7.75C8.125 9.19922 6.94922 10.375 5.5 10.375C4.05078 10.375 2.875 9.19922 2.875 7.75V3.375C2.875 1.92578 4.05078 0.75 5.5 0.75ZM2 6.65625V7.75C2 9.69141 3.55859 11.25 5.5 11.25C7.41406 11.25 9 9.69141 9 7.75V6.65625C9 6.30078 9.27344 6 9.65625 6C10.0117 6 10.3125 6.30078 10.3125 6.65625V7.75C10.3125 10.2109 8.48047 12.207 6.15625 12.5352V13.4375H7.46875C7.82422 13.4375 8.125 13.7383 8.125 14.0938C8.125 14.4766 7.82422 14.75 7.46875 14.75H5.5H3.53125C3.14844 14.75 2.875 14.4766 2.875 14.0938C2.875 13.7383 3.14844 13.4375 3.53125 13.4375H4.84375V12.5352C2.49219 12.207 0.6875 10.2109 0.6875 7.75V6.65625C0.6875 6.30078 0.960938 6 1.34375 6C1.69922 6 2 6.30078 2 6.65625Z",
    fill: "#33FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOn);
export default __webpack_public_path__ + "static/media/mic-on.35ceda6f70cf1545f47473622dbc43d9.svg";
export { ForwardRef as ReactComponent };